// Setup › DIGITAL EMPLOYEES › Deploys (`/c/{slug}/setup/deploys`) and Standing orders & models
// (`/c/{slug}/setup/de-overrides`): the company side of DC-04's deploy approval and template
// override (screens DC-05). Core feature, managers (the Setup gate); approving is the owner's or
// the agency operator's, setting the override an owner's or admin's.
import { createRoute } from "@tanstack/react-router";
import { CompanyDeploysScreen } from "../features/de/deploy-approvals";
import { TemplateOverrideScreen } from "../features/de/template-override";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupDeploysRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "deploys",
  component: function SetupDeploys() {
    const { api } = setupDeploysRoute.useRouteContext();
    return <CompanyDeploysScreen api={api} company={useCompany()} />;
  },
});

export const setupDeOverridesRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "de-overrides",
  component: function SetupDeOverrides() {
    const { api } = setupDeOverridesRoute.useRouteContext();
    return <TemplateOverrideScreen api={api} company={useCompany()} />;
  },
});
